import axios from 'axios';

export const PORTAL_TOKEN_KEY = 'portalToken';
export const ADMIN_TOKEN_KEY = 'portalAdminToken';

const makeClient = (tokenKey, loginPath) => {
  const client = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL, timeout: 30000 });
  client.interceptors.request.use((config) => {
    const token = localStorage.getItem(tokenKey);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  client.interceptors.response.use(
    (r) => r,
    (error) => {
      if (error.response?.status === 401 && localStorage.getItem(tokenKey)) {
        localStorage.removeItem(tokenKey);
        if (!window.location.pathname.endsWith('/login')) window.location.assign(loginPath);
      }
      return Promise.reject(error);
    }
  );
  return client;
};

export const portalApi = makeClient(PORTAL_TOKEN_KEY, '/customer-portal/login');
export const adminApi = makeClient(ADMIN_TOKEN_KEY, '/Customer-dashboard/login');

export const apiError = (e, fallback = 'Something went wrong. Please try again.') => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(' ');
  return d.msg || String(d);
};

export const fmtDate = (v, opts = {}) => {
  if (!v) return '—';
  const d = new Date(v);
  if (isNaN(d)) return '—';
  return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', ...opts });
};

export const fmtAgo = (v) => {
  if (!v) return '—';
  const diff = Math.max(0, Date.now() - new Date(v).getTime());
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'just now';
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} hr ago`;
  return `${Math.floor(h / 24)} d ago`;
};

export const fmtDuration = (minutes) => {
  if (minutes == null) return '—';
  if (minutes < 60) return `${minutes} min`;
  const h = Math.floor(minutes / 60);
  if (h < 24) return `${h} hr ${minutes % 60} min`;
  return `${Math.floor(h / 24)} d ${h % 24} hr`;
};

export const STATE_STYLES = {
  online: { color: 'bg-emerald-500', text: 'text-emerald-700 dark:text-emerald-300', soft: 'bg-emerald-50 dark:bg-emerald-900/30', pulse: true },
  offline: { color: 'bg-red-500', text: 'text-red-700 dark:text-red-300', soft: 'bg-red-50 dark:bg-red-900/30', pulse: true },
  maintenance: { color: 'bg-blue-500', text: 'text-blue-700 dark:text-blue-300', soft: 'bg-blue-50 dark:bg-blue-900/30', pulse: false },
  service_inactive: { color: 'bg-gray-400', text: 'text-gray-700 dark:text-gray-300', soft: 'bg-gray-100 dark:bg-gray-800', pulse: false },
  monitoring_unavailable: { color: 'bg-gray-400', text: 'text-gray-700 dark:text-gray-300', soft: 'bg-gray-100 dark:bg-gray-800', pulse: false },
  unknown: { color: 'bg-gray-400', text: 'text-gray-700 dark:text-gray-300', soft: 'bg-gray-100 dark:bg-gray-800', pulse: false },
};

export const ACCOUNT_STYLES = {
  Active: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
  Inactive: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
  Suspended: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
  Expired: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
  'Under Maintenance': 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
};

export const TICKET_STATUS_STYLES = {
  Submitted: 'bg-blue-100 text-blue-800', Open: 'bg-blue-100 text-blue-800', Assigned: 'bg-indigo-100 text-indigo-800', 'In Progress': 'bg-amber-100 text-amber-800',
  'Awaiting Customer Response': 'bg-orange-100 text-orange-800', Escalated: 'bg-red-100 text-red-800', Resolved: 'bg-emerald-100 text-emerald-800',
  Closed: 'bg-gray-200 text-gray-700', Reopened: 'bg-purple-100 text-purple-800',
};

export const tid = (id) => String(id || '').replace(/\//g, '~');
